import React from 'react';
import { Star, Zap, MessageCircle, Search } from 'lucide-react';

/**
 * Hero section component with search functionality and feature highlights
 */
const HeroSection = ({ searchQuery, setSearchQuery }) => (
  <div className="bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white py-20 relative overflow-hidden">
    <div className="absolute inset-0 bg-black/20"></div>
    <div className="absolute top-10 left-10 w-32 h-32 bg-yellow-400/10 rounded-full blur-xl"></div>
    <div className="absolute bottom-10 right-10 w-48 h-48 bg-pink-400/10 rounded-full blur-xl"></div>
    
    <div className="max-w-6xl mx-auto px-6 relative z-10 text-center">
      <h1 className="text-6xl font-bold mb-6 bg-gradient-to-r from-yellow-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
        Discover Your Next Great Read
      </h1>
      <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto leading-relaxed">
        From timeless classics to modern bestsellers, find the perfect book for every mood and moment. 
        Your literary adventure starts here.
      </p>
      
      <div className="flex flex-wrap justify-center gap-4 mb-8">
        <div className="flex items-center space-x-2 bg-white/10 px-4 py-2 rounded-full backdrop-blur">
          <Star className="w-5 h-5 text-yellow-400" />
          <span>Curated Collection</span>
        </div>
        <div className="flex items-center space-x-2 bg-white/10 px-4 py-2 rounded-full backdrop-blur">
          <Zap className="w-5 h-5 text-green-400" />
          <span>Instant Delivery</span>
        </div>
        <div className="flex items-center space-x-2 bg-white/10 px-4 py-2 rounded-full backdrop-blur">
          <MessageCircle className="w-5 h-5 text-blue-400" />
          <span>AI Recommendations</span>
        </div>
      </div>
      
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <div className="flex-1 max-w-md">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Search for books, authors, genres..."
              className="w-full pl-12 pr-4 py-4 rounded-2xl bg-white/95 text-gray-800 shadow-xl focus:ring-4 focus:ring-purple-300 border-0 text-lg"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
        <button className="bg-gradient-to-r from-yellow-400 to-orange-400 hover:from-yellow-500 hover:to-orange-500 text-black font-bold px-8 py-4 rounded-2xl shadow-xl transform hover:scale-105 transition-all duration-300">
          <Search className="w-5 h-5 inline mr-2" />
          Search Books
        </button>
      </div>
    </div>
  </div>
);

export default HeroSection;
